import { ApiError } from "@vana/core";

export class ListTopicsError extends ApiError {}
export class MarkTopicError extends ApiError {}
export class UnmarkTopicError extends ApiError {}
export class CompleteTrainingError extends ApiError {}
